import useReportsFiltersetSelectionState from "recoilStore/useReportsSetSelectionState";
import useFiltersetState from "recoilStore/Filters/useFilterset";
import { useCreateReportFilterset } from "mutations/Measures/useCreateReportFiltersetMutation";

function useCurrentFilterset() {
    const { state: reportedVsPublishedState, setState: setStateReportedVsPublished } =
        useReportsFiltersetSelectionState();
    const {
        state: filtersetUidState,
        setState: setStateFiltersetUid,
        resetState: resetFiltersetState,
    } = useFiltersetState();
    const { isLoading } = useCreateReportFilterset();

    let selectedFiltersetUid = null;
    if (
        !isLoading &&
        filtersetUidState.reportsPageReportedFilterset !== null &&
        filtersetUidState.reportsPagePublishedFilterset !== null
    ) {
        selectedFiltersetUid =
            reportedVsPublishedState === "reported"
                ? filtersetUidState.reportsPageReportedFilterset
                : filtersetUidState.reportsPagePublishedFilterset;
    }

    return {
        reportedVsPublishedState,
        setStateReportedVsPublished,
        filtersetUidState,
        setStateFiltersetUid,
        selectedFiltersetUid,
        resetFiltersetState,
        isLoading,
    };
}

export default useCurrentFilterset;
